import React from "react";
import { useOfferCard } from "../../../../components/OfferCard/useOfferCard";
import { InitialOfferCTA } from "../../../../components";
import { useLocation } from "react-router-dom";
import { PromoReminder } from "../../../InitialOffer/components";
import { PromoApplied } from "../PromoApplied";
import PromoTicker from "../../../InitialOffer/components/PromoTicker";

export const OfferCardInitialValuation = ({
  startTicker,
  handleApplyPromo,
  showLoader,
  isInitialValuation,
  showSpinner,
  onSubmit,
  promoActionNotRequired,
  showBranchValuationContent,
  isPartExchangeCustomer
}) => {
  const { valuation, promoApplied, offerCopy, noPromo } = useOfferCard();

  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      <div
        className={
          "ch-card ch-pa--3 sm:ch-pa--5 ch-display--flex ch-flex-flow--column-nowrap ch-align-items--center ch-pb--1 initial-offer-card-part-exchange part-exchange-card-border--top-card ch-shadow--sm part-exchange-card-border--top-card part-exchange-card-border--top-card ch-mb--6"
        }
      >
        <div
          className={`${promoApplied && !showLoader ? "promo-fade-in" : ""} ch-width--12`}
        >
          <>
            <div className="ch-text--center ch-width--12">
              {promoApplied && !showLoader && (
                <PromoApplied promotionalBonus={valuation?.promotionalBonus} />
              )}

              <p className="ch-fs--4 sl:ch-fs--5 ch-mb--0 ch-text--center">
                {promoApplied && !showLoader
                  ? "Your updated valuation"
                  : offerCopy}
              </p>

              <p
                className={`offer-price ${noPromo ? "" : "space-numbers-evenly"} ch-text--bold ch-mb--1`}
              >
                <span>£</span>
                {promoApplied ? (
                  valuation?.valuation.toLocaleString()
                ) : promoActionNotRequired ? (
                  valuation?.valuationBeforePromotion.toLocaleString()
                ) : (
                  <PromoTicker
                    startTicker={startTicker}
                    valuationBeforePromo={valuation?.valuationBeforePromotion}
                    valuationAfterPromo={valuation?.valuation}
                  />
                )}
                <span>*</span>
              </p>

              {promoApplied && valuation?.promotionAppliedToValuation && (
                <p className="ch-text--capitalize ch-mb--0 price-no-promo ch-text--bold">
                  was £{valuation?.valuationBeforePromotion.toLocaleString()}
                </p>
              )}
              {showLoader ? (
                <div
                  className="ch-skeleton ch-mt--3"
                  style={{ height: "300px" }}
                />
              ) : (
                <>
                  {!promoActionNotRequired && (
                    <div className="ch-width--12 ch-display--flex ch-justify-content--center">
                      <PromoReminder
                        promotionalBonus={valuation?.promotionalBonus}
                        handleApplyPromo={handleApplyPromo}
                      />
                    </div>
                  )}
                  {(promoActionNotRequired && showBranchValuationContent) ||
                  !showBranchValuationContent ||
                  (promoApplied && showBranchValuationContent)
                    ? !isInitialValuation && (
                        <hr className="ch-mv--3 ch-width--8 ch-bg--grey-3" />
                      )
                    : null}
                  {promoActionNotRequired && (
                    <>
                      <div className="ch-width--12">
                        <InitialOfferCTA
                          promoActionNotRequired={promoActionNotRequired}
                          isPartExchangeCustomer={isPartExchangeCustomer}
                        />
                      </div>
                      <div className="ch-text-divider ch-width--12 ch-mv--2 sm:ch-mv--3">
                        <p className="ch-fs--3 ch-fw--500 ch-mb--0 ch-color--grey-6">
                          or
                        </p>
                      </div>
                      <div className="ch-width--12">
                        <button
                          className={`ch-btn ch-btn--success ch-display--flex ch-mh--auto ch-width--12 ${
                            showSpinner ? "ch-btn--loading" : ""
                          }`}
                          type="button"
                          onClick={() => onSubmit(pathname)}
                          data-testid="initial-offer-cta"
                        >
                          Continue with this valuation
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};
